export default [
    {
        path: '/bills/unsent',
        name: 'billsUnsent',
        component: () => import( /* webpackChunkName: "unsentBills" */ '@/views/notifications/UnsentBills.vue')
    },
    {
        path: '/events/unsent',
        name: 'eventsUnsent',
        component: () => import( /* webpackChunkName: "eventsUnsent" */ '@/views/notifications/UnsentEvents.vue')
    },
    {
        path: '/fileResponses/unsent',
        name: 'fileResponsesUnsent',
        component: () => import( /* webpackChunkName: "fileResponsesUnsent" */ '@/views/notifications/UnsentFileResponses.vue')
    },
    {
        path: '/messages/unsent',
        name: 'messagesUnsent',
        component: () => import( /* webpackChunkName: "messagesUnsent" */ '@/views/notifications/UnsentMessages.vue')
    },
    {
        path: '/notes/unsent',
        name: 'notesUnsent',
        component: () => import( /* webpackChunkName: "notesUnsent" */ '@/views/notifications/UnsentNotes.vue')
    },
    // {
    //     path: '/notifications/unsent',
    //     name: 'notificationsUnsent',
    //     component: () => import( /* webpackChunkName: "notificationsUnsent" */ '@/views/notifications/UnsentNotifications.vue')
    // },
    {
        path: '/scheduledQuoteEmails/unsent',
        name: 'scheduledQuoteEmailsUnsent',
        component: () => import( /* webpackChunkName: "scheduledQuoteEmailsUnsent" */ '@/views/notifications/UnsentQuoteEmails.vue')
    },
    {
        path: '/uploadFiles/unsent',
        name: 'uploadFilesUnsent',
        component: () => import( /* webpackChunkName: "uploadFilesUnset" */ '@/views/notifications/UnsentUploadFiles.vue')
    },
    {
        path: '/uploadFileShares/unsent',
        name: 'uploadFileSharesUnsent',
        component: () => import( /* webpackChunkName: "uploadFileSharesUnsent" */ '@/views/notifications/UnsentUploadFileShares.vue')
    }

]